// Per-column table filter model shared by DataGrid's funnel dropdown + the
// right-click cell context menu (mirrors risk-dashboard-table-filters.js).

export type ColFilter =
  | { op: 'in'; values: string[] }
  | { op: 'contains'; text: string }
  | { op: 'equals'; value: string }
  | { op: 'notEquals'; value: string };

export function matchesFilter(cell: string, f: ColFilter): boolean {
  switch (f.op) {
    case 'in':
      return f.values.length === 0 || f.values.includes(cell);
    case 'contains':
      return cell.toLowerCase().includes(f.text.toLowerCase());
    case 'equals':
      return cell === f.value;
    case 'notEquals':
      return cell !== f.value;
  }
}

// Chip label — "∋" for contains, "≠" for not-equals (as in the legacy chip bar).
export function filterChipText(title: string, f: ColFilter): string {
  switch (f.op) {
    case 'in':
      return `${title}: ${f.values.join(', ')}`;
    case 'contains':
      return `${title} ∋ ${f.text}`;
    case 'equals':
      return `${title}: ${f.value}`;
    case 'notEquals':
      return `${title} ≠ ${f.value}`;
  }
}
